module.exports = __webpack_public_path__ + "static/media/ncl-logo-hor.5031be27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/ncl-logo-hor.png
// module id = 328
// module chunks = 21